<div class="users-page">
    <div class="settings-header">
        <div class="settings-header-row">
            <div class="left">
                <div class="d-flex align-items-center">
                    <a (click)="closeSettings()" class="cursor d-flex align-items-center back">
                        <mat-icon>keyboard_arrow_left</mat-icon>
                        {{ 'BUTTONS.BACK' | translate }}
                    </a>
                </div>
                <h1 class="title">{{ 'USER.SETTINGS' | translate }}</h1>
                <div class="center">
                    <button class="users-button large-button" (click)="changeMenu(1)"
                    [ngClass]="selectedTab == 1 ? 'active' : ''">{{ 'USER.AREA_SITES' | translate }}</button>
                    <button class="users-button"(click)="changeMenu(2)"
                    [ngClass]="selectedTab == 2 ? 'active' : ''">{{ 'USER.USERS' | translate }}</button>
                    <button class="users-button"(click)="changeMenu(3)"
                    [ngClass]="selectedTab == 3 ? 'active' : ''">{{ 'USER.COMPANY' | translate }}</button>
                </div>
            </div>
            
            <div class="right">
            </div>
        </div>
    </div>
<app-sites-area *ngIf="selectedTab == 1" [countries]="countries" [organizations]="organizations"></app-sites-area>
<app-users *ngIf="selectedTab == 2" [selectedUserId]="selectedUserId" [selectedSiteId]="null"></app-users>
<app-company *ngIf="selectedTab == 3" (selectedUserId)="onUserSelected($event)" [countries]="countries" [organizations]="organizations"></app-company>
</div>